var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.25V5.75H16V7.25H13ZM13.8542 13L11.3958 11.2917L12.2708 10.0625L14.7292 11.7708L13.8542 13ZM12.25 2.9375L11.3958 1.70833L13.8542 0L14.7083 1.22917L12.25 2.9375ZM2 12.5V8.5H1.5C1.0875 8.5 0.734375 8.35313 0.440625 8.05938C0.146875 7.76563 0 7.4125 0 7V6C0 5.5875 0.146875 5.23438 0.440625 4.94063C0.734375 4.64688 1.0875 4.5 1.5 4.5H4.39583L9 1.75V11.25L4.52083 8.5H4V12.5H2ZM7.5 8.5625V4.39583L4.8125 6H1.5V7H4.95833L7.5 8.5625ZM10 8.9375V4.0625C10.3194 4.36806 10.566 4.73611 10.7396 5.16667C10.9132 5.59722 11 6.04167 11 6.5C11 6.95833 10.9132 7.40278 10.7396 7.83333C10.566 8.26389 10.3194 8.63194 10 8.9375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampaigns);
export default __webpack_public_path__ + "static/media/icon-campaigns.12111b6bfed8e80f2253c709e22905d7.svg";
export { ForwardRef as ReactComponent };